import type {
    LoginRequestType,
    LoginResponseType,
    RegisterRequestType,
    RegisterResponseType,
    VerifyRequestType,
    VerifyResponseType,
} from "@src/types";
import { auth, publicApi } from "./client";

export async function loginApi(payload: LoginRequestType): Promise<LoginResponseType> {
    const access_token = await auth.login({
        username: payload.username,
        password: payload.password,
        grant_type: "password",
    });

    return { access_token, token_type: "bearer" };
}

export async function registerApi(payload: RegisterRequestType): Promise<RegisterResponseType> {
    const { data } = await publicApi.post<RegisterResponseType>("/api/auth/register", payload);
    return data;
}

export async function verifyApi(payload: VerifyRequestType): Promise<VerifyResponseType> {
    const { data } = await publicApi.post<VerifyResponseType>("/api/auth/register", payload);
    return data;
}
